'use client';

import React from 'react';

import { CodeLoginForm, PasswordLoginForm } from './_components';

import {
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@/components';
import { useTranslation } from '@/hooks';

const SignIn: React.FC = () => {
  const { t } = useTranslation('pages.signIn.form');
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);

  return (
    <Stack flex={1} w="full" h="100%" gap={0}>
      <Text
        textAlign="center"
        fontSize={{ base: 'md', md: 'xl' }}
        w="full"
        fontWeight="medium"
      >
        {selectedTabIndex === 0 ? t('loginHint') : t('loginHint2')}
      </Text>
      <Tabs
        isLazy
        w="100%"
        flex={1}
        mt={{ base: '50px', md: '80px' }}
        index={selectedTabIndex}
        onChange={setSelectedTabIndex}
        display="flex"
        flexDir="column"
      >
        <TabList w="fit-content" borderBottomColor="transparent">
          <Tab
            paddingInline="0"
            me={8}
            sx={{
              _selected: {
                color: 'primary.500',
                borderBottomColor: 'primary.500',
                borderBottomWidth: '2px',
              },
            }}
          >
            {t('loginWithPassword')}
          </Tab>
          <Tab
            paddingInline="0"
            sx={{
              _selected: {
                color: 'primary.500',
                borderBottomColor: 'primary.500',
                borderBottomWidth: '2px',
              },
            }}
          >
            {t('code')}
          </Tab>
        </TabList>
        <TabPanels display="flex" flexDir="column" flex={1}>
          <TabPanel display="flex" flexDir="column" flex={1} p={0}>
            <PasswordLoginForm />
          </TabPanel>
          <TabPanel display="flex" flexDir="column" flex={1} p={0}>
            <CodeLoginForm />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Stack>
  );
};

export default SignIn;
